export const WIDGET_CODES = {
  MOST_WIDESPREAD_TAG: 'MOST_WIDESPREAD_TAG',
  TOP_TRENDING_TAGS: 'TOP_TAGS',
  FP_AVG: 'FP_AVG',
};
